// src/components/admin/JobPostsTab.js
import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import API_BASE_URL from '../../utils/apiConfig';
import apiClient from '../../utils/api';
import AdminJobDetailModal from '../AdminJobDetailModal';
import '../../pages/AdminDashboard.css';

const JobPostsTab = ({ jobsData, setJobsData, onDataRefresh }) => {
    const { firebaseUser } = useAuth(); 
    const [filter, setFilter] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');  // Added Search State
    const [selectedJob, setSelectedJob] = useState(null);
    const [notifyState, setNotifyState] = useState({});

    const handleAction = async (job, action) => {
        let newStatus = job.status;
        let shouldNotify = false;
        let isDelete = false;

        switch(action) {
            case 'approve':
                newStatus = 'approved';
                shouldNotify = !!notifyState[job.id];
                break;
            case 'reject':
                newStatus = 'rejected';
                break;
            case 'delete':
                if (!window.confirm("Are you sure you want to delete this job post permanently?")) return;
                isDelete = true;
                break;
            default:
                return;
        }
                    try {
            // CHANGE 2: Use firebaseUser here. This has the .getIdToken function.
            const idToken = await firebaseUser.getIdToken(true);
            
            if (isDelete) {
                // Handle Delete
                await apiClient.delete(`/admin/jobs/${job.id}`, {
                    headers: { Authorization: `Bearer ${idToken}` }
                });
                alert('Job deleted successfully!');
            } else {
                // Handle Approve/Reject
                // Update local UI state immediately (Optimistic UI)
                const updatedJobs = jobsData.map(j => 
                    j.id === job.id ? { ...j, status: newStatus } : j
                );
                setJobsData(updatedJobs);

                await apiClient.put(`/admin/jobs/${job.id}/status`, 
                  { status: newStatus, notify: shouldNotify }, 
                  { headers: { Authorization: `Bearer ${idToken}` } }
                );
            }
            
            // Refresh data from server to ensure everything is in sync
            onDataRefresh();

        } catch (error) {
            console.error(`Action failed for ${job.id}:`, error);
            alert(`Error: ${error.response?.data?.message || error.message}`);
            onDataRefresh(); // Revert UI changes on error
        }
    };

    const filteredJobs = jobsData.filter(job => {
        const matchesFilter = filter === 'all' || job.status === filter;
        const s = searchTerm.toLowerCase();
        const matchesSearch = 
            job.title?.toLowerCase().includes(s) || 
            job.companyName?.toLowerCase().includes(s) || 
            job.userName?.toLowerCase().includes(s);
        
        return matchesFilter && matchesSearch;
    });

    return (
        <div>
            <div className="admin-controls-row" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <div className="filter-buttons" style={{ margin: 0 }}>
                    <button onClick={() => setFilter('all')} className={filter === 'all' ? 'active' : ''}>All ({jobsData.length})</button>
                    <button onClick={() => setFilter('pending')} className={filter === 'pending' ? 'active' : ''}>Pending ({jobsData.filter(j => j.status === 'pending').length})</button>
                    <button onClick={() => setFilter('approved')} className={filter === 'approved' ? 'active' : ''}>Approved ({jobsData.filter(j => j.status === 'approved').length})</button>
                    <button onClick={() => setFilter('rejected')} className={filter === 'rejected' ? 'active' : ''}>Rejected ({jobsData.filter(j => j.status === 'rejected').length})</button>
                </div>
                {/* SEARCH BAR */}
                <div className="search-container">
                    <input 
                        type="text" 
                        placeholder="Search Job, Company or Author..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="admin-search-input"
                    />
                </div>
            </div>
            <div className="table-wrapper">
                <table className="news-table">
                  <thead><tr><th>Job Title</th><th>Company/Type</th><th>Author</th><th>Status</th><th>Actions</th><th>Details</th></tr></thead>
                  <tbody>
                    {filteredJobs.map(job => (
                        <tr key={job.id}>
                            <td>{job.title}</td>
                            <td>{job.jobType === 'private' ? job.companyName : 'Government'}</td>
                            <td>{job.userName}<br/>{job.userContact}</td>
                            <td><span className={`status-pill status-${job.status}`}>{job.status}</span></td>
                            <td className="action-buttons">
                                {/* Show "Approve" if the status is NOT 'approved' */}
                                {job.status !== 'approved' && (
                                    <div className="approve-action">
                                        <button className="approve-btn" onClick={() => handleAction(job, 'approve')}>
                                        Approve
                                        </button>
      {/* The notify checkbox should only appear for pending jobs */}
                                    {job.status === 'pending' && (
                                        <label className="notify-label">
                                            <input type="checkbox" checked={!!notifyState[job.id]} onChange={() => setNotifyState(prev => ({...prev, [job.id]: !prev[job.id]}))} />
                                            Notify
                                        </label>
                                    )}
                                </div>
                            )}
                                {job.status !== 'rejected' && (
                                    <button className="reject-btn" onClick={() => handleAction(job, 'reject')}>Reject</button>
                                )}
                                <button className="delete-btn" onClick={() => handleAction(job, 'delete')}>Delete</button>
                            </td>
                            <td className="details-cell"><button className="details-btn" onClick={() => setSelectedJob(job)}><i className="fas fa-ellipsis-v"></i></button></td>
                        </tr>
                    ))}
                  </tbody>
                </table>
            </div>
            {selectedJob && <AdminJobDetailModal job={selectedJob} onClose={() => setSelectedJob(null)} />}
        </div>
    );
};

export default JobPostsTab;